<template>
  <div class="box_account">
    <div class="form_container">
      <div class="data-div d-flex flex-row justify-content-between align-items-stretch">
        <div
          class="d-flex flex-column"
          style="max-width: 50%"
        >
          <h4 class="font-weight-bold mb-0 mt-1">
            {{ Number(info.general_data.total_people).toLocaleString('de-DE') }}
          </h4>
          <span class="color-gray mt-auto">
            {{ $t('lang.transfer.users') }}
          </span>
        </div>
        <div class="d-flex flex-column">
          <h5 class="reputation">
            <i
              v-for="(icon, index) in getReputationIcons(info.general_data.rating/2)"
              :key="index"
              :class="icon"
            />
          </h5>
          <span class="color-gray">
            <b-link
              class="mt-auto color-gray"
              @click="$bvModal.show('reviews-modal')"
            >
              {{ $t('lang.transfer.see_reviews',
                    {reviews: Number(info.general_data.reviews).toLocaleString('de-DE') })
              }}
            </b-link>
          </span>
        </div>
      </div>
    </div>

    <b-modal
      id="reviews-modal"
      hide-footer
      hide-header
      centered
      size="md"
      content-class="p-3 text-center bg-light styled-modal"
    >
      <div class="row">
        <h4 class="new-modal-title mb-2">
          {{ $t('lang.transfer.reviews_title') }}
        </h4>

        <div
          class="col-12 pt-4"
          style="max-height: 300px; overflow-y: scroll;"
        >
          <div
            v-for="(review, index) in info.reviews"
            :key="'review_'+index"
            class="strip list_view mb-4"
          >
            <div class="row no-gutters">
              <div class="col-12 p-3">
                <h5 class="reputation">
                  <i
                    v-for="(icon, index) in getReputationIcons(review.rating)"
                    :key="index"
                    :class="icon"
                  />
                </h5>
                <p class="m-0 pt-3">
                  {{ review.text }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 text-center mt-4">
          <button
            id="btn_close"
            type="submit"
            class="btn btn-main-color m-2 pl-4 pr-4"
            name="btn_close"
            @click="$bvModal.hide('reviews-modal');"
          >
            {{ $t('lang.forms.back') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'CityInfo',

  props: {
    info: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getReputationIcons(rating) {
      let reputation = Math.trunc(rating);
      const iconsArray = [];
      if (reputation > 5) {
        // Sometimes it might have an unreal or big number.
        reputation = 5;
      }
      for (let i = 0; i < reputation; i++) {
        iconsArray.push('icon-star');
      }

      const dec = reputation - reputation;

      if (dec >= 0.3 && dec <= 0.7) {
        iconsArray.push('icon-star-half-alt');
      } else if (dec > 0.7) {
        iconsArray.push('icon-star');
      }

      for (let i = iconsArray.length; i < 5; i++) {
        iconsArray.push('icon-star-empty');
      }

      return iconsArray;
    },
  },
};
</script>

<style scoped>

.data-div{
  max-width: 500px;
  text-align: center;
  margin: auto;
}

h5{
  margin-bottom: 0;
}

.reputation i, .reputation i:before {
  font-size: 1.7rem!important;
  margin: 0;
  text-align: left;
  color: gold;
}
.reputation span{
  font-weight: 500;
  color: #999;
  font-size: .8rem;
}
</style>
